<template>
  <div class="b-slide-filters">
    <div class="b-slide-filters__label" @click="toggleFilters">
      {{ label }}
      <img src="/imgs/icons/select-icon.png" alt="filter-icon" />
    </div>

    <div class="b-slide-filters__filters" :class="showClass">
      <div class="b-slide-filters__title">{{ label }}</div>

      <Dropdown
        :options="companyNameOptions"
        :label="companyNameLabel"
        :is-mobile="true"
        @select-dropdown="getCompanyNameValue"
        @reset="resetName"></Dropdown>

      <Dropdown
        :options="yearsOptions"
        :label="yearLabel"
        :is-mobile="true"
        @select-dropdown="getYearValue"
        @reset="resetYear"></Dropdown>

      <div class="b-slide-filters__cta">
        <button type="button" class="btn btn-secondary" @click="selectFilters">
          <span>{{ buttonLabel }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from './Dropdown.vue'
export default {
  components: { Dropdown },
  props: {
    label: {
      type: String,
    },
    buttonLabel: {
      type: String,
    },
    yearsOptions: {
      type: Array,
    },
    yearLabel: {
      type: String,
    },
    companyNameOptions: {
      type: Array,
    },
    companyNameLabel: {
      type: String,
    },
  },
  data() {
    return {
      showFilters: false,
      year: '',
      name: '',
    }
  },
  computed: {
    showClass() {
      return this.showFilters ? 'show' : ''
    },
  },
  mounted() {},

  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters
      jQuery('html').addClass('scrollDisabled')
    },

    selectFilters() {
      this.showFilters = false
      jQuery('html').removeClass('scrollDisabled')

      this.$emit('change-filters', this.name, this.year)
    },

    getYearValue(year) {
      this.year = year
    },

    getCompanyNameValue(name) {
      this.name = name
    },

    resetYear() {
      this.year = ''
      this.$emit('reset-year', this.year)
    },

    resetName() {
      this.name = ''

      this.$emit('reset-name', this.name)
    },
  },
}
</script>
